import React from 'react';

import Usuario from '../index';

const Medico: React.FC = () => {
  return <Usuario tipo="medico" />;
};

export default Medico;
